import { axiosInstance } from "#services/axiosInstance.js";
import { useMutation } from "react-query";

const usePost = (url, queryKey) => {
  const { mutate, isLoading, error, mutateAsync, isSuccess } = useMutation(
    queryKey,
    async (data) => {
      const result = await axiosInstance({
        method: "post",
        url: url,
        data: data,
      });
      return result.data;
    },
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return { mutate, isLoading, error, mutateAsync, isSuccess };
};

export default usePost;
